module.exports = __webpack_public_path__ + "static/media/Screenshot_8-thumb.0b876490.png";